// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switchContainer__rChJ_4IfFx{cursor:pointer}.switch__z5756Nqere>label{margin:0}.tooltip__M68PU5Rvmu{width:260px}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/analytics/components/controls/components/context/components/multiToggle/contextMultiToggle.module.scss"],"names":[],"mappings":"AAAA,6BACE,cAAA,CAIA,0BACE,QAAA,CAIJ,qBACE,WAAA","sourcesContent":[".switchContainer {\n  cursor: pointer;\n}\n\n.switch {\n  & > label {\n    margin: 0;\n  }\n}\n\n.tooltip {\n  width: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchContainer": `switchContainer__rChJ_4IfFx`,
	"switch": `switch__z5756Nqere`,
	"tooltip": `tooltip__M68PU5Rvmu`
};
export default ___CSS_LOADER_EXPORT___;
